import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import DashboardHome from "@/pages/DashboardHome";
import EmployeeRoster from "@/pages/EmployeeRoster";
import MyProfile from "@/pages/MyProfile";
import ClientAccounts from "@/pages/ClientAccounts";
import TaskBoard from "@/pages/TaskBoard";
import FinancialLedger from "@/pages/FinancialLedger";
import KnowledgeHub from "@/pages/KnowledgeHub";
import ResearchArchive from "@/pages/ResearchArchive";
import Opportunities from "@/pages/Opportunities";
import EventContacts from "@/pages/EventContacts";
import PortalDashboard from "@/pages/PortalDashboard";
import Templates from "@/pages/Templates";
import SOPLibrary from "@/pages/SOPLibrary";
import CompanyRecords from "@/pages/CompanyRecords";
import CompanyProfile from "@/pages/CompanyProfile";
import ActivityLogs from "@/pages/ActivityLogs";
import MyClients from "@/pages/MyClients";
import ExpenseTracker from "@/pages/ExpenseTracker";
import Assistant from "@/pages/Assistant";
import SocialMedia from "@/pages/SocialMedia";
import MeetingDiscussions from "@/pages/MeetingDiscussions";
import Leads from "@/pages/Leads";
import MySchedule from "@/pages/MySchedule";
import PurchaseInvoices from "@/pages/PurchaseInvoices";
import FinancialOverview from "@/pages/FinancialOverview";
import CaAccess from "@/pages/CaAccess";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/portal" element={<ProtectedRoute clientOnly><PortalDashboard /></ProtectedRoute>} />
          <Route path="/" element={<ProtectedRoute><DashboardHome /></ProtectedRoute>} />
          <Route path="/employees" element={<ProtectedRoute adminOnly><EmployeeRoster /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><MyProfile /></ProtectedRoute>} />
          <Route path="/clients" element={<ProtectedRoute adminOnly><ClientAccounts /></ProtectedRoute>} />
          <Route path="/my-clients" element={<ProtectedRoute><MyClients /></ProtectedRoute>} />
          <Route path="/tasks" element={<ProtectedRoute><TaskBoard /></ProtectedRoute>} />
          <Route path="/ledger" element={<ProtectedRoute allowedRoles={["admin", "employee", "ca"]}><FinancialLedger /></ProtectedRoute>} />
          <Route path="/knowledge" element={<ProtectedRoute><KnowledgeHub /></ProtectedRoute>} />
          <Route path="/research" element={<ProtectedRoute><ResearchArchive /></ProtectedRoute>} />
          <Route path="/opportunities" element={<ProtectedRoute><Opportunities /></ProtectedRoute>} />
          <Route path="/event-contacts" element={<ProtectedRoute adminOnly><EventContacts /></ProtectedRoute>} />
          <Route path="/templates" element={<ProtectedRoute adminOnly><Templates /></ProtectedRoute>} />
          <Route path="/sops" element={<ProtectedRoute><SOPLibrary /></ProtectedRoute>} />
          <Route path="/company-records" element={<ProtectedRoute adminOnly><CompanyRecords /></ProtectedRoute>} />
          <Route path="/company-profile" element={<ProtectedRoute><CompanyProfile /></ProtectedRoute>} />
          <Route path="/activity-logs" element={<ProtectedRoute adminOnly><ActivityLogs /></ProtectedRoute>} />
          <Route path="/expenses" element={<ProtectedRoute allowedRoles={["admin", "ca"]}><ExpenseTracker /></ProtectedRoute>} />
          <Route path="/assistant" element={<ProtectedRoute><Assistant /></ProtectedRoute>} />
          <Route path="/social-media" element={<ProtectedRoute><SocialMedia /></ProtectedRoute>} />
          <Route path="/meeting-discussions" element={<ProtectedRoute><MeetingDiscussions /></ProtectedRoute>} />
          <Route path="/leads" element={<ProtectedRoute><Leads /></ProtectedRoute>} />
          <Route path="/my-schedule" element={<ProtectedRoute><MySchedule /></ProtectedRoute>} />
          <Route path="/purchase-invoices" element={<ProtectedRoute allowedRoles={["admin", "ca"]}><PurchaseInvoices /></ProtectedRoute>} />
          <Route path="/financial-overview" element={<ProtectedRoute allowedRoles={["admin", "ca"]}><FinancialOverview /></ProtectedRoute>} />
          <Route path="/ca-access" element={<ProtectedRoute adminOnly><CaAccess /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
